import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/sagas/funnelChart";
import { useDispatch, useSelector } from "react-redux";

export const SubAverageFilter = () => {
  const dispatch = useDispatch();

  const average = useSelector((state) => state.laser.selectedFilters.average);
  const subAverageFilterOptions = useSelector((state) => state.laser.subAverageFilterOptions);
  const selected = useSelector((state) => state.laser.selectedFilters.subAverageFilterOptions);

  return subAverageFilterOptions[average]?.length ? (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">{average}</p>
      <MultiSelectDropdown
        options={subAverageFilterOptions[average]}
        selectedFilters={selected}
        onSelectChange={(data) => dispatch(actionCreators.setSubAverageSelectedOptions(data))}
        enableOnly
        numberDisplayed={0}
        includeSelectAll
        haveOnSelectChange
      />
    </div>
  ) : null;
};
